module.exports = __webpack_public_path__ + "static/media/wave.385d5422.png";